module.exports = __webpack_public_path__ + "img/responsive-badge.6a1f7011.svg";